export default __webpack_public_path__ + "static/media/pic7.ac09d6fb.jpg";